import React, { useContext } from 'react'
import { t } from '@lingui/macro'
import { PagePanel } from '../../../components/common/page/Page'

import { CertificateTemplatePageHeader } from './CertificateTemplatePageHeader'
import { CertificateTemplatePreview } from './CertificateTemplatePreview'
import { ManageCertificationPageContext } from '../manage/ManageCertificationPage'
import { usePatchCertificationMutation } from '../manage/CertificationsDrawer.codegen'

export const CertificateTemplate = () => {
  const { certification, refetch } = useContext(ManageCertificationPageContext)
  const [patch] = usePatchCertificationMutation()

  return (
    <PagePanel>
      <CertificateTemplatePageHeader
        header={t`Used template`}
        templateId={certification.template_id}
        onSelect={async (value) => {
          await patch({
            variables: {
              id: certification.id,
              data: {
                template_id: value
              }
            }
          })
          refetch()
        }}
      />

      {certification.template_id && (
        <CertificateTemplatePreview templateId={certification.template_id} />
      )}
    </PagePanel>
  )
}
